// extracted by mini-css-extract-plugin
export default {"button":"LockButton_button__VBx-C"};